import { navigate } from "gatsby-link";
import { useEffect, useState } from "react";
import { SERPConfig } from "../../plugins/gatsby-source-serp/types";

const hashTrigger = "#jobs";

function addExitIntentHash() {
  if (window.location.hash === hashTrigger) return;
  navigate(window.location.pathname + window.location.search + hashTrigger);
}

export default function useExitItem(
  hash: Location["hash"],
  hasExitIntent: SERPConfig["hasExitIntent"]
) {
  const [exitItentActive, setExitItentModal] = useState(false);

  useEffect(() => {
    if (!hasExitIntent) return;
    const addExitIntentHashTrigger = () => addExitIntentHash();
    window.addEventListener("click", addExitIntentHashTrigger, { once: true });
    return () => {
      window.removeEventListener("click", addExitIntentHashTrigger);
    };
  }, [hasExitIntent]);

  useEffect(() => {
    if (!hasExitIntent) return;
    function invokeExitIntentOnPop() {
      if (hash === hashTrigger) {
        setExitItentModal(true);
      }
    }
    window.addEventListener("popstate", invokeExitIntentOnPop);
    return () => {
      window.removeEventListener("popstate", invokeExitIntentOnPop);
    };
  }, [hash, setExitItentModal, hasExitIntent]);

  if (!hasExitIntent) {
    return {};
  }

  return {
    addExitIntentHash,
    exitItentActive,
  };
}
